import { Injectable } from '@angular/core';

/**
 * Reproduce sonidos de notificación sintetizados con WebAudio, sin archivos de audio.
 */
@Injectable({
  providedIn: 'root',
})
export class SoundService {
  private static readonly VOLUME = 0.18;
  private context: AudioContext | null = null;

  /** Timbre clásico: dos tonos descendentes a intervalo de tercera mayor (B5 → G5). */
  playDingDong(): void {
    try {
      const context = this.getContext();
      if (!context) return;

      if (context.state === 'suspended') context.resume().catch(() => {});

      const now = context.currentTime;
      this.playTone(context, 987.77, now, 0.45);
      this.playTone(context, 783.99, now + 0.28, 0.75);
    } catch (error) {
      console.error('Error playing notification sound:', error);
    }
  }

  /**
   * El contexto se crea recién en el primer uso: creado antes de que el usuario interactúe con la
   * página, la política de autoplay lo deja en estado `suspended`.
   */
  private getContext(): AudioContext | null {
    if (this.context) return this.context;

    const AudioContextCtor = window.AudioContext || (window as any).webkitAudioContext;
    if (!AudioContextCtor) return null;

    this.context = new AudioContextCtor();
    return this.context;
  }

  private playTone(context: AudioContext, frequency: number, startAt: number, duration: number): void {
    const oscillator = context.createOscillator();
    const gain = context.createGain();

    oscillator.type = 'sine';
    oscillator.frequency.setValueAtTime(frequency, startAt);

    gain.gain.setValueAtTime(0.0001, startAt);
    gain.gain.exponentialRampToValueAtTime(SoundService.VOLUME, startAt + 0.02);
    gain.gain.exponentialRampToValueAtTime(0.0001, startAt + duration);

    oscillator.connect(gain).connect(context.destination);
    oscillator.start(startAt);
    oscillator.stop(startAt + duration + 0.05);
  }
}
